import React from 'react'
import { Skeleton } from '@mui/material'
import {
  ExampleCardSkeletonContainer,
  ExampleCardSkeletonTextContainer,
} from '../styled/skeleton/ExampleCardSkeleton.styled'

// Loading placeholder shaped like one ExamplePage list item. Co-located styled subcomponents
// mirror the convention used for every other component in this scaffold.
const ExampleCardSkeleton: React.FC = () => {
  return (
    <ExampleCardSkeletonContainer>
      <Skeleton variant="rounded" width={64} height={64} />
      <ExampleCardSkeletonTextContainer>
        <Skeleton variant="text" width="60%" />
        <Skeleton variant="text" width="80%" />
      </ExampleCardSkeletonTextContainer>
    </ExampleCardSkeletonContainer>
  )
}

export default ExampleCardSkeleton
